import clsx from 'clsx'
import {MfaMethodType, mfaMethodMeta} from '../core/mfaApi'
import './MfaMethodPicker.scss'

type Props = {
  methods: MfaMethodType[]
  selectedMethod: MfaMethodType | null
  onSelect: (method: MfaMethodType) => void
  onContinue: () => void
  loading?: boolean
  title?: string
  subtitle?: string
  continueLabel?: string
}

export function MfaMethodPicker({
  methods,
  selectedMethod,
  onSelect,
  onContinue,
  loading = false,
  title = 'Choose a verification method',
  subtitle = "Select how you'd like to receive your verification codes when signing in",
  continueLabel = 'Continue',
}: Props) {
  return (
    <div className='mfa-method-picker'>
      <h2 className='mfa-method-picker__title'>{title}</h2>
      <p className='mfa-method-picker__subtitle'>{subtitle}</p>

      <div className='mfa-method-picker__options'>
        {methods.map((method) => {
          const meta = mfaMethodMeta(method)
          const selected = selectedMethod === method
          const iconStyle = selected ? meta.selectedIconStyle : meta.iconStyle

          return (
            <button
              key={method}
              type='button'
              className={clsx('mfa-method-picker__option', selected && 'mfa-method-picker__option--selected')}
              onClick={() => onSelect(method)}
              disabled={loading}
            >
              <div className='mfa-method-picker__icon' style={iconStyle}>
                <i className={`bi ${meta.icon}`} />
              </div>
              <div className='mfa-method-picker__content'>
                <div className='mfa-method-picker__name'>{meta.title}</div>
                <p className='mfa-method-picker__description'>{meta.description}</p>
              </div>
              <div
                className={clsx('mfa-method-picker__radio', selected && 'mfa-method-picker__radio--selected')}
                aria-hidden
              />
            </button>
          )
        })}
      </div>

      <button
        type='button'
        className='mfa-method-picker__continue'
        onClick={onContinue}
        disabled={loading || selectedMethod == null}
      >
        {loading ? 'Please wait...' : continueLabel}
      </button>
    </div>
  )
}
